import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/zh-TW";
import axios from "axios";
import VueAxios from "vue-axios";
import JsonCSV from "vue-json-csv";
import TextHighlight from "vue-text-highlight";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Pagination from "./components/Pagination.vue";
import Breadcrumb from "./components/Breadcrumb.vue";

import api from "./api/api.js";
import dayjs from "./day.js";
import "@/permission.js";
import { queryRecord } from "./utils/userquery.js";

// OSM Map 
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet.wmts'
import 'leaflet.markercluster'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import 'leaflet.markercluster/dist/leaflet.markercluster.js'


Vue.config.productionTip = false;
Vue.use(ElementUI, { locale });

Vue.use(VueAxios, axios);
Vue.use(require("vue-moment"));
Vue.use(dayjs);
Vue.component("downloadCsv", JsonCSV);
Vue.component("text-highlight", TextHighlight);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("Pagination", Pagination);
Vue.component("Breadcrumb", Breadcrumb);

// 除錯環境變數
// console.log('Environment variables:');
// console.log('VUE_APP_BASE_API:', process.env.VUE_APP_BASE_API);
// console.log('VUE_APP_BASE_SYSTOKEN:', process.env.VUE_APP_BASE_SYSTOKEN);
// console.log('NODE_ENV:', process.env.NODE_ENV);




Vue.prototype.$api = api;
Vue.prototype.$queryRecord = queryRecord;
import "./assets/all.scss";

library.add(fas);

store.dispatch("RefreshSessionToken", { logoutOnFail: true })
  .finally(() => store.dispatch("InitBranchLocation"))
  .finally(() => {
    new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount("#app");
  });
